import { z } from "zod";
import { ComponentRoleSchema } from "./component-role.js";
export const SurfaceTypeSchema = z.enum([
    "marketingSite",
    "landingPage",
    "servicePage",
    "locationPage",
    "publicExample",
]);
export const ContentEntityTypeSchema = z.enum([
    "localServiceBusiness",
    "service",
    "location",
    "product",
    "event",
    "caseStudy",
    "offer",
]);
export const UniversalSurfaceGrammarV1Schema = z
    .object({
    schemaVersion: z.literal("universal-surface-grammar.v1.0"),
    grammarVersion: z.string().min(1),
    roles: z.array(ComponentRoleSchema),
    surfaceTypes: z.array(SurfaceTypeSchema),
    contentEntityTypes: z.array(ContentEntityTypeSchema),
    deprecatedAliases: z
        .record(ComponentRoleSchema)
        .default({ serviceAreaBlock: "locationCoverageBlock" }),
})
    .strict();
//# sourceMappingURL=surface-grammar.js.map